import React from "react";
import { Button, Form, Modal } from "antd";

function AdvanceButton({ form, label, type, disabled, confirmationPopUp, btnIndex, setAdvanceBtnIndex }) {

  const onClickHandler = () => {
    form
      .validateFields()
      .then(() => {
        console.log(btnIndex);
        setAdvanceBtnIndex(btnIndex);
        // Validation is successful
        if (confirmationPopUp) {
          Modal.confirm({
            title: confirmationPopUp["text"],
            okText: confirmationPopUp["okButtonLabel"],
            cancelText: confirmationPopUp["cancelButtonLabel"],
            cancelButtonProps: { ghost: true },
            okButtonProps: { ghost: true, danger: true },
            onOk: form.submit,
          });
        } else {
          form.submit();
        }
      })
      .catch((errors) => {
        // Errors in the fields
      });
  };
  return (
    <Form.Item
      className="formBtnGroup"
      colon={false}
      style={{
        marginTop: "20px",
        display: "flex",
        justifyContent: "center",
        marginBottom: 0,
        textAlign: "center",
      }}
    >
      <Button
        id="submitButtonForm"
        style={{
          marginLeft: "30px",
          fontWeight: 600,
          borderRadius: "10px",
          // marginBottom: 0,
        }}
        disabled={disabled}
        type={type}
        htmlType={"button"}
        onClick={onClickHandler}
      >
        {label}
      </Button>
    </Form.Item>
  );
}

export default AdvanceButton;